// import { CloseOutlined, SearchOutlined } from '@ant-design/icons'
// import { useDebounce, useEventEmitter, useLocalStorageState } from 'ahooks'
// import { AutoComplete, Input } from 'antd'
import React from 'react'

// import { useTranslation } from 'react-i18next'
// import { useHistory, useLocation } from 'react-router-dom'

// import { useSearchStateQuery } from '@/generated/graphql'
// import { SearchSuggestions } from '@/modules/search'
// import { routes } from '@/routes'

// import { emptySearchState, searchState } from '../search.state'
import s from './search-input.module.less'

// const TaleSearchHistoryStoreVersion = 'TaleSearchHistoryStoreV2'

export const SearchInput: React.FC<{ title?: React.ReactElement | null }> = ({ title }) => {
  const titleComponent = (
    <span className={title ? s.title : s.icon}>
      {title ? (
        title
      ) : (
        <img
          className={s.icon}
          src={'https://agora-web-cdn.oss-cn-beijing.aliyuncs.com/tale/tale-logo-no-padding@2x.png'}
          width={20}
          height={20}
          alt='Tale Logo'
        />
      )}
    </span>
  )
  return <div className={s.search}>{titleComponent}</div>
  // const { t } = useTranslation()
  // const key$ = useEventEmitter<string>()
  // const history = useHistory()
  // const location = useLocation()
  // const inputRef = React.useRef<HTMLInputElement>(null)
  // const [input, setInput] = React.useState('')
  // const debouncedSearch = useDebounce(input, { wait: 300, leading: true })
  // const { data } = useSearchStateQuery()
  // const [histories, setHistories] = useLocalStorageState<string[]>(TaleSearchHistoryStoreVersion, [])
  // // 点击首页清除搜索框
  // React.useEffect(() => {
  //   if (location.pathname === '/') {
  //     searchState(emptySearchState)
  //     setInput('')
  //   }
  // }, [location.key])
  // React.useEffect(() => {
  //   searchState({ ...searchState(), input: debouncedSearch })
  // }, [debouncedSearch])
  // const onSearch = (search: string) => {
  //   searchState({ ...searchState(), search })
  //   if (search) {
  //     history.push(routes.search.home())
  //   }
  // }
  // const onChange = (input = '') => setInput(input)
  // const onCancel = () => {
  //   setInput('')
  // }
  // const inputValue = data?.searchState.input || ''
  // const options =
  //   inputValue || histories.length === 0
  //     ? []
  //     : [
  //         {
  //           label: (
  //             <div className={s.historyBar}>
  //               <span>{t('search.history')}</span>
  //               <span onClick={() => setHistories([])}>{t('search.clearHistory')}</span>
  //             </div>
  //           ),
  //           options: histories.map((history) => ({ value: history })),
  //         },
  //       ]
  // return (
  //   <>
  //     <div className={s.search}>
  //       {titleComponent}
  //       <AutoComplete style={{ width: '100%' }} options={options} onChange={onChange} onSelect={onSearch} value={input}>
  //         <Input
  //           ref={(ref) => ((inputRef as any).current = ref?.input)}
  //           prefix={<SearchOutlined />}
  //           allowClear
  //           placeholder={t('search.search')}
  //           inputMode={'search'}
  //           onClick={() => key$.emit('focus')}
  //           onPressEnter={(e) => {
  //             setInput('')
  //             if (searchState().selectionIndex === -1) {
  //               onSearch(e.currentTarget.value)
  //             } else {
  //               key$.emit('enter')
  //             }
  //           }}
  //           onKeyDown={(e) => key$.emit(e.key)}
  //         />
  //       </AutoComplete>
  //       {input && (
  //         <span className={s.cancel} onClick={onCancel}>
  //           <CloseOutlined />
  //         </span>
  //       )}
  //     </div>
  //     {inputValue ? <SearchSuggestions key$={key$} histories={histories} setHistories={setHistories} /> : children}
  //   </>
  // )
}
